import { countRunes, trimGoSpace } from './goText'

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const MAX_EMAIL_RUNES = 255

export function isLikelyEmail(value: string): boolean {
  const email = trimGoSpace(value)
  return countRunes(email) <= MAX_EMAIL_RUNES && EMAIL_PATTERN.test(email)
}
